'use client';

import { createContext } from 'react';

import type { ComboboxOptionContextInterface } from '../types/combobox-option.types';

export const ComboboxOptionContext = createContext<ComboboxOptionContextInterface>({});

ComboboxOptionContext.displayName = 'Combobox.Option.Context';
